<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent top-navbar"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row md-layout">
      <div class="md-layout-item md-size-20">
        <!-- <h3 class="md-title">{{ $route.name }}</h3> -->
        <div class="logo topnav-logo">
          <a
            href="/"
            class="simple-text logo-normal"
          >
            <div class="logo-img">
              <img :src="logo" />
            </div>
          </a>
        </div>
      </div>
      <slot />
      
    </div>
    <div class="help md-button md-icon-button md-info" v-if="showHelpIcon">
      <a
        href="http://ausloans.atlassian.net/servicedesk/customer/portals"
        class=""
        target="_blank"
      >
        <i class="md-icon md-size-2x">help</i>
      </a>
      <md-tooltip md-direction="bottom">Help and Knowledge Hub</md-tooltip>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
    };
  },
  props: {
    logo: {
      type: String,
      default: require("@/assets/img/zink-logo-text-positive.png")
    },
    showHelpIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.top-navbar {
  z-index: 3;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 25%);
  padding-right: 70px;
}
.topnav-logo .logo {
  margin-left: -20px;
}

.logo-img img {
  height: 57px;
}

.help {
  position:absolute;
  right:24px;
  top:24px;
  width:48px;
}
@media screen and (max-width:992px) {
  .top-navbar {
    display: none;
  }
}
.md-tooltip::after {
  margin-right: 25px;
}
</style>
